export var translationPath = function (baseUrl, locale) {
    if (locale === void 0) { locale = 'en'; }
    return baseUrl + "assets/locale/productWidget/productWidget_" + locale + ".json";
};
export var widgetId = '13ec3e79-e668-cc0c-2d48-e99d53a213dd';
export var MULTILINGUAL_TO_TRANSLATIONS_MAP = {
    NAVIGATE_TO_PRODUCT_PAGE_BUTTON: 'PRODUCT_WIDGET_BUTTON_TEXT',
    ADD_TO_CART_BUTTON: 'PRODUCT_WIDGET_BUTTON_TEXT',
};
export var PRODUCT_WIDGET_APP_NAME = 'wixstores-product-widget';
//# sourceMappingURL=constants.js.map